import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { auth } from './Firebase';

export const reauthenticate = password => {

    const user = auth.currentUser;
    const credentials = EmailAuthProvider.credential(user.email, password);

    return reauthenticateWithCredential(user, credentials);
}